import type { Law } from '~/utils/solr/law'
import { sortByPrimaryIdentity, stableSort } from '~/utils/catalogue-relevance'
import { parseToChronology } from '~/utils/sort'
import { compareLocaleNorwegian, normalizeSearchText } from '~/utils/string'

export type FilteredLaw = Law & { isFavorite: boolean }
export type LawGroup = { heading: string | null; laws: FilteredLaw[] }

function getTitle(law: FilteredLaw): string {
  return law.shortTitleWithoutAbbreviation ?? law.title ?? ''
}

function compareTitle(left: FilteredLaw, right: FilteredLaw): number {
  return compareLocaleNorwegian(
    left.shortTitle || left.title || '',
    right.shortTitle || right.title || '',
  )
}

function compareChronology(left: FilteredLaw, right: FilteredLaw): number {
  const difference =
    parseToChronology(right.lastChangeInForce || right.dateInForce || '') -
    parseToChronology(left.lastChangeInForce || left.dateInForce || '')
  const leftTitle = left.shortTitleWithoutAbbreviation || left.title || ''
  const rightTitle = right.shortTitleWithoutAbbreviation || right.title || ''
  return difference || compareLocaleNorwegian(leftTitle, rightTitle)
}

export function buildLawCatalogueGroups(
  grouped: Record<string, FilteredLaw[]>,
  query: string,
  sortValue: string,
): LawGroup[] {
  const flat = Object.values(grouped).flat()
  if (sortValue === 'kronologisk') {
    return flat.length ? [{ heading: null, laws: stableSort(flat, compareChronology) }] : []
  }
  if (sortValue === 'relevans' && normalizeSearchText(query)) {
    const laws = sortByPrimaryIdentity(
      flat,
      query,
      (law) => [getTitle(law), law.abbreviation],
      compareTitle,
    )
    return laws.length ? [{ heading: null, laws }] : []
  }
  return Object.entries(grouped).map(([heading, laws]) => ({ heading, laws }))
}
